<template>
  <div class="w-100">
    <div class="card shadow overflow-hidden p-0 mx-0" :class="{ hide: submitted }">
      <form class="w-100" method="post" novalidate @submit.prevent>
        <div class="card-body px-4 py-4">
          <div class="form-group row flex-column" :class="{ error: valorError }">
            <label class="col font-PM text-gray mb-3" for="valor">Ingresá el valor mensual del alquiler</label>
            <div class="col">
              <div class="content-element bg-white border border-borders rounded-lg overflow-hidden">
                <div class="element-form-ico w-100 text-primary d-flex align-items-stretch">
                  <div
                    class="pre bg-light border-right border-borders d-flex justify-content-center align-items-center p-2">
                    <h2 class="font-PM text-nowrap px-2 mb-0">$</h2>
                  </div>
                  <input v-model="form.valor" type="text"
                    class="form-control h-auto form-control-lg border-0 text-primary text-left" id="valor" name="valor"
                    placeholder="50.000" maxlength="8" required>
                </div>
              </div>
              <p class="error-messages small text-danger my-2" v-if="valorError">{{ valorError }}</p>
            </div>
          </div>
          <div
            class="form-group row flex-column flex-sm-row no-gutters justify-content-center align-items-center border border-borders rounded p-3">
            <label class="col font-PM text-gray pr-0 pr-sm-4 my-2 my-sm-1">¿Posee garantía?</label>
            <div class="content-element bg-transparent wrapper-btn-drop-auto p-1 my-2 my-sm-1 ml-n3 ml-sm-0">
              <div class="row no-gutters justify-content-center align-items-center flex-nowrap">
                <div class="order-1">
                  <a :class="{ 'selected': !form.garantia, 'move-circle': form.garantia }"
                    class="btn btn-text btn-sm font-R active-circle-button-left text-gray text-left text-uppercase w-100 px-2 py-0 mb-0"
                    @click="toggleGarantia">
                    <div class="font-sm-small d-flex text-center text-sm-left">de &nbsp;<br
                        class="d-block d-sm-none">propiedad</div>
                  </a>
                </div>
                <div class="order-3">
                  <a :class="{ 'selected': form.garantia, 'move-circle': !form.garantia }"
                    class="btn btn-text btn-sm font-R active-circle-button-right text-gray text-left text-uppercase w-100 px-2 py-0 mb-0"
                    @click="toggleGarantia">
                    <div class="font-sm-small text-center text-sm-left">de &nbsp;<br class="d-block d-sm-none">caución
                    </div>
                  </a>
                </div>
                <div class="btn-drop btn btn-left rounded-pill bg-light border border-borders order-2 py-0"></div>
              </div>
            </div>
          </div>
        </div>
        <div class="card-footer bg-transparent border-0 px-4 pt-2 pt-md-4 pb-0">
          <div class="row justify-content-center align-items-center">
            <div class="col-md-12">
              <div class="row no-gutters justify-content-end">
                <button type="button" @click="submit" :disabled="valorError"
                  class="btn btn-outline-primary rounded-pill cta-start mb-4">
                  Ver resultado
                </button>
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>
    <!--resultado-->
    <div class="col-lg-12 mb-4 mb-xl-5" v-if="submitted">
      <div class="row">
        <div class="col-md-12 card rounded-top-0 shadow overflow-hidden mx-0 py-3 mb-4">
          <div class="row no-gutters justify-content-center align-items-center bg-primary rounded py-5">
            <div class="col-md-9 text-center py-4 py-xl-5">
              <img src="/images/icons/percentage.svg" class="mb-4" alt="resultado">
              <div class="result mb-4">
                <div class="element-form-ico w-100 d-flex justify-content-center align-items-center text-white">
                  <h2 class="font-PB text-nowrap text-center mb-0">$ <span id="cont-resultado">{{
                    numeral(this.total).format('0,000.00') }}</span>
                  </h2>
                </div>
              </div>
              <!--<p class="font-S text-white mb-4 pb-3">Gastos totales del alquiler</p>-->
              <div>
                <button type="button" @click="reset" class="btn btn-secondary rounded-pill">Volver a
                  calcular
                </button>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-12">
          <p class="small font-R text-gray"><b>Aclaración:</b> El monto representa una estimación de gastos que afronta
            una persona al inicio de un contrato de alquiler. Contempla el mes de depósito y el mes de adelanto. No
            incluye los gastos de mudanza, ni las comisiones inmobiliarias ya que quien los asume depende de la
            localidad en la que se efectúe el contrato.</p>
        </div>
      </div>
    </div>
    <!--fin resultado-->
  </div>
</template>


<script>
import { ref } from 'vue';

export default {
  setup() {
    const form = ref({
      garantia: false,
      valor: null
    });
    const submitted = ref(false);
    const valorError = ref('');

    const submit = () => {
      if (form.value.valor === null || !/^\d+$/.test(form.value.valor)) {
        valorError.value = 'Ingrese un valor válido.';
        return;
      }

      valorError.value = '';
      submitted.value = true;

    };

    const reset = () => {
      submitted.value = false;
      form.value = {
        garantia: false,
        valor: null
      };
    };

    const toggleGarantia = () => {
      form.value.garantia = !form.value.garantia;
    };

    return {
      form,
      submitted,
      valorError,
      submit,
      reset,
      toggleGarantia
    };
  }
};

</script>

<style lang="scss">
a {
  cursor: pointer;
}
</style>
